import React, { FC, useEffect } from 'react';
import cs from 'classnames';
import s from './mobileApp.scss';
import { reportLoadSuccess } from '../../utils/bi';
import { MobileToolbar } from '../MobileToolbar/MobileToolbar';
import { monitoring } from '../../utils/monitoring';
import { useTemplateContext } from '../../context/TemplateContext';
import { useUIContext } from '../../context/UIContext';
import { InfoButton } from '../InfoButton/InfoButton';
import { InfoPopUp } from '../InfoPopUp/InfoPopUp';
import { mobileAppDataHooks } from './MobileApp.dataHooks';
import { MobileWixStudioToolbar } from '../MobileWixStudioToolbar/MobileWixStudioToolbar';
import { buildIframeUrl } from '../../utils/urlBuilders';

export const MobileApp: FC = () => {
  const { isInfoShown } = useUIContext();
  const template = useTemplateContext();
  const previewUrl = buildIframeUrl(template.publicUrl, { showMobileView: true });

  useEffect(() => {
    reportLoadSuccess();
    monitoring.appLoaded();
  }, []);

  return (
    <div>
      {template.isStudio ? (
        <MobileWixStudioToolbar dataHook={mobileAppDataHooks.wixStudioToolbar} />
      ) : (
        <MobileToolbar dataHook={mobileAppDataHooks.mobileToolBar}>
          <InfoButton dataHook={mobileAppDataHooks.infoView} />
        </MobileToolbar>
      )}
      <iframe
        data-hook={mobileAppDataHooks.mobileIframe}
        title={template.title}
        src={previewUrl}
        className={cs(s.iframe, { [s.iframeHidden]: isInfoShown })}
      />
      {!template.isStudio && <InfoPopUp isMobile dataHook={mobileAppDataHooks.infoPopUp} />}
    </div>
  );
};
